// extracted by mini-css-extract-plugin
module.exports = {"title":"AppNewsList_title__KedJq","appNewsCardTitle":"AppNewsList_appNewsCardTitle__3EEbQ","appNewsCardSubtitle":"AppNewsList_appNewsCardSubtitle__2OoeK"};